export const CookieExpireAfter = days => {
  var now = new Date();

  // Calculate the new date by adding the number of days
  var targetDate = new Date(now);
  targetDate.setDate(now.getDate() + days);

  return targetDate;
}
